import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPQantTabula = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("image", {
		width: 18,
		height: 18,
		href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAvklEQVR4AexTQQ6CQAycylfwARoPeFueoeEvhL8YfQZ7k4PRB8hXSO1QPSxXvEGTSduZzWzSphv8Kdyo0oCTtjirjpn994PD/R12Xd/uu16nIE+dT91oQA1BAIOZPWvDIFIL4BrSIE+drBuxmgk3ytBAEcFgZs/akKk2CriGNMhTJ+tGF4m4SYmryJjZUzU8jtv4KvLyWeQyBXnq9gxuxGom3KjSdWvpINW2mdlWyfqMuKV1a5zHD2I3uIBb+wAAAP//DCPnkAAAAAZJREFUAwD1XdUl1PXVBQAAAABJRU5ErkJggg=="
	})
});
export default SvgPQantTabula;
